<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-magnify</v-icon>
              <v-toolbar-title>View Debit Note</v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="tabNav">
              <v-tab @click.native="doMandatory(0)">Mandatory</v-tab>
              <v-tab @click.native="doOptional(1)">Optional</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabNav">
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory">
                <form data-vv-scope="debitNoteMandatoryForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.branch }}</v-subheader>
                              <div class="queryValue" v-for="item in filterBranchList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" :label="debitNoteFormLabel.docAE" v-model="debitNoteForm.docAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.documentNo }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.documentNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.transactionDate }}</v-subheader>
                              <div class="queryValue">{{ convertDate(debitNoteForm.transactionDate) }}</div>
                            </v-flex>
                            <v-flex md5 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.accountNo }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAccountNoList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md3 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.fund }}</v-subheader>
                              <div class="queryValue" v-for="item in filterFundList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md5 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.accountNoSuffix }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAccountNoSuffixList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.gstIO }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstIOList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.gstStatus }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstStatusList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.gstRate }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.gstRate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.amountCurr }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAmountCurrList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.amount }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.amount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.gstAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(debitNoteForm.gstAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" :label="debitNoteFormLabel.gstAmountAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.gstAmount }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.gstAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.netAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(debitNoteForm.netAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.netAmount }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.netAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.netLocalAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(debitNoteForm.netLocalAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox
                                color="primary"
                                :label="debitNoteFormLabel.netAmountLocalAE"
                                v-model="debitNoteForm.netAmountLocalAE"
                                disabled
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.netLocalAmount }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.netLocalAmount }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.createdBy + ' on ' + debitNoteForm.createdDate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.modifiedBy + ' on ' + debitNoteForm.modifiedDate }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="optional">
                <form data-vv-scope="debitNoteOptionalForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12 lg12>
                              <div class="header-padding body-2">Document Details</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.printDocument }}</v-subheader>
                              <div class="queryValue" v-for="item in filterPrintDocumentList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.addressTo }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAddressToList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.policyNo }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.policyNo }}</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.companyName }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.companyName }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.docAddress1 }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.docAddress1 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.docAddress2 }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.docAddress2 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.docAddress3 }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.docAddress3 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.docAddress4 }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.docAddress4 }}</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.postalCode }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.postalCode }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.details }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.details }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.statementRef }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.statementRef }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm12 lg12>
                              <div class="header-padding body-2">Other Details</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.department }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAddressToList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.insuredName }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.insuredName }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.claimNo }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.claimNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.gstRegNo }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.gstRegNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.taxInvoiceNo }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.taxInvoiceNo }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
            </v-tabs-items>

            <v-flex xs12>
              <v-btn color="error" dark @click.prevent="doCancel">
                {{ actionLabel.cancel }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
            </v-flex>
            <!-- CBO Added: Oct-05-2020 Comments -->
            <v-layout row wrap>
              <v-flex lg12 xs12 order-lg1 order-xs2>
                <common-comments :commentRefNo="this.commentRefNo" :commentTranType="this.commentTranType" :mode="'query'"></common-comments>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="processingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred when review Debit Note.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { debitNoteAjaxMixin } from '@/mixins/accounting/debitNote/debitNoteAjaxMixin'
import { debitNoteViewMixin } from '@/mixins/accounting/debitNote/debitNoteViewMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate } from '@/utils/date'
import CommonComments from '@/components/core/accounting/CommonComments'

export default {
  data() {
    return {
      tabNav: 0,
      acctNoSfxApplnInt: '60',
      actionLabel: {
        cancel: 'Cancel',
        saveAndReview: 'Save & Review',
        saveAndPost: 'Save & Post',
        matchNow: 'Match Now'
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      loading: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      accounts: [],
      accountdata: {},
      acctnosuffixes60: [],
      amountcurrencies: [],
      amountcurrencydata: {},
      departments: [],
      miscacctparams: [],
      funds: [],
      currencies: [],
      isMandatory: true,
      isOptional: false,
      trandaterange: {},
      gstStatuses: [],
      gstrate: '0.00',
      baseCurrency: ''
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    debitNoteData() {
      return this.$store.state.debitNote.debitNoteData
    },
    displayErrorDialog() {
      return this.messages
    },
    filterBranchList() {
      return this.branches.filter((list) => {
        return list.value === this.debitNoteForm.branch
      })
    },
    filterAccountNoList() {
      return this.accounts.filter((list) => {
        return list.value === this.debitNoteForm.accountNo
      })
    },
    filterFundList() {
      return this.funds.filter((list) => {
        return list.value === this.debitNoteForm.fund
      })
    },
    filterAccountNoSuffixList() {
      return this.acctnosuffixes60.filter((list) => {
        return list.value === this.debitNoteForm.accountNoSuffix
      })
    },
    filterGstIOList() {
      return this.gstIO.filter((list) => {
        return list.value === this.debitNoteForm.gstIO
      })
    },
    filterGstStatusList() {
      return this.gstStatuses.filter((list) => {
        return list.value === this.debitNoteForm.gstStatus
      })
    },
    filterAmountCurrList() {
      return this.amountcurrencies.filter((list) => {
        return list.value === this.debitNoteForm.amountCurr
      })
    },
    filterPrintDocumentList() {
      return this.printDocOpts.filter((list) => {
        return list.value === this.debitNoteForm.printDocument
      })
    },
    filterAddressToList() {
      return this.addressToOpts.filter((list) => {
        return list.value === this.debitNoteForm.addressTo
      })
    },
    filterDepartmentList() {
      return this.departments.filter((list) => {
        return list.value === this.debitNoteForm.department
      })
    },
    apiURI() {
      return this.$store.state.debitNote.menu
    },
    commentRefNo() {
      const data = this.$store.state.debitNote.debitNoteData
      return data.accountNo + data.documentNo + data.fund + data.suffix + data.branch + data.type
    },
    commentTranType() {
      return this.$store.state.debitNote.debitNoteData.type
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('debitNoteInit')])
      this.fetchBranch()
      this.fetchAccount()
      this.fetchAcctNoSfx60()
      this.fetchAmountCurrency()
      this.fetchFund()
      this.fetchDepartment()
      this.fetchGstStatus()
      this.fetchCurrency()
      await Promise.all([this.performReview()])
    },
    filterCurrList(curr) {
      const data = this.currencies.find(list => list.value === curr)
      return data ? data.label : ''
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    },
    doMandatory(tabId) {
      this.isMandatory = true
      this.isOptional = false
      this.validStatus.optional = true
      this.validStatus.mandatory = true
      this.tabNav = tabId
    },
    doOptional(tabId) {
      this.isMandatory = false
      this.isOptional = true
      this.validStatus.mandatory = true
      this.validStatus.optional = true
      this.tabNav = tabId
    },
    doCancel() {
      this.$router.push({ name: 'debitNote' }).catch(() => {})
    }
  },
  created() {},
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, debitNoteAjaxMixin, debitNoteViewMixin, commonAjaxMixin],
  components: {
    CommonComments
  }
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
